import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/home/index.vue'
import Model from '../views/model/index.vue'
const routes = [
  {
    path: '/model',
    name: 'model',
    component: Model,
  },
  {
    path: '/',
    name: 'home',
    component: HomeView,
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
})

export default router
